<template>
  <div
    id="contactus"
    class="page"
  >
    <template v-if="!loading">
      <Banner :banner="page.banner" />
      <section
        id="content_section"
        class="container bg-white text-left"
      >
        <div class="row">
          <div
            class="py-4 pb-5"
            :class="page.sidemenu? 'col-lg-9 order-lg-2': 'col-lg-12'"
          >
            <Breadcrumb :items="[{ name: page.title, url: path }]" />
            <div class="content py-4">
              <div class="grid container">
                <div
                  v-for="item in items"
                  :id="item.id"
                  :key="item.id"
                  class="row align-items-center"
                >
                  <div class="col-2 text-center">
                    <img
                      v-view.once
                      :src="item.image"
                      border="0"
                      width="50"
                      class="animated fadeInLeft"
                    >
                  </div>
                  <div class="col-10">
                    <h6 class="text-uppercase text-osc">
                      {{ item.name }}:
                    </h6>
                    <p
                      class="mb-0"
                      v-html="item.value"
                    />
                    <p
                      v-if="item.desc"
                      class="mb-0"
                    >
                      {{ item.desc }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SideMenu
            v-if="page.sidemenu"
            class="py-4 col-lg-3 order-lg-1"
            :data="page.sidemenu"
          />
        </div>
      </section>
      <section
        id="donate_btn_section"
        class="container bg-white py-4 clearfix d-none d-md-block"
      >
        <DonateBtn
          v-view.once
          class="animated fadeInRight"
        />
      </section>
    </template>
  </div>
</template>
<script>
import Banner from "@/components/Banner.vue";
import DonateBtn from "@/components/DonateBtn.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import SideMenu from "@/components/SideMenu.vue";
import * as _ from "lodash";

export default {
  name: "ContactUs",
  components: { Banner, DonateBtn, SideMenu, Breadcrumb },
  data() {
    let to = this.$router.history.current;
    return {
      path: to.path,
      loading: true,
      page: {
        // Default Settings for page
        sidemenu: {},
        banner: null,
        title: this.$t("page.contactus")
      },
      items: [
        {
          id: "telephone",
          name: this.$t("component.contact_us.telephone"),
          // value: "+852 " + localStorage.telephone,
          value: `<a href="tel:${localStorage.telephone}">+852 ${
            localStorage.telephone
          }</a>`,
          image: this.getAssetLink(
            "/assets/media/theme/icon/icon_telephone2.png"
          ),
          desc: this.$t("component.contact_us.telephone_desc")
        },
        {
          id: "fasimile",
          name: this.$t("component.contact_us.fasimile"),
          value: "+852 " + localStorage.fasimile,
          image: this.getAssetLink("/assets/media/theme/icon/icon_fax2.png"),
          desc: null
        },
        {
          id: "email",
          name: this.$t("component.contact_us.email"),
          value: `<a href="mailto:${localStorage.email}">${
            localStorage.email
          }</a>`,
          image: this.getAssetLink("/assets/media/theme/icon/icon_email2.png"),
          desc: this.$t("component.contact_us.enquiry_desc")
        },
        {
          id: "postal_address",
          name: this.$t("component.contact_us.postal_address"),
          value:
            this.$i18n.locale == "en"
              ? localStorage.address
              : localStorage.address_cht,
          image: this.getAssetLink("/assets/media/theme/icon/icon_map.png"),
          desc: this.$t("component.contact_us.enquiry_desc")
        }
      ]
    };
  },
  mounted() {
    this.$http
      .get(this.path)
      .then(response => {
        if (response.data.success) {
          this.data = response.data.data;

          this.page.banner = this.data.image;
          this.page.title =
            this.getDataValue("name", this.data) || this.page.title;
          this.page.heading =
            this.getDataValue("headline", this.data) || this.page.heading;

          let past_bene =
            this.data &&
            this.getDataValue("left_menu_header", this.data) ==
              this.$t("component.past_beneficiaries");
          let current_bene =
            this.data &&
            this.getDataValue("left_menu_header", this.data) ==
              this.$t("component.beneficiaries");
          if (past_bene || current_bene) {
            this.page.sidemenu["past_bene"] = past_bene;
            this.page.sidemenu["current_bene"] = current_bene;
          }
          if (_.isEmpty(this.page.sidemenu)) this.page.sidemenu = null; // Hide SideMenu if there're no items

          this.$route.meta.title = this.page.title;
          this.$route.meta.desc = this.data.desc;
          this.$meta().refresh(); // Important!
        } else {
          if (typeof response.data == "string") {
            throw new Error(response.data);
          } else {
            throw new Error(response.data.error);
          }
        }
      })
      .catch(error => {
        let response = error.response;
        if (response && (response.status == 404 || response.status === 401)) {
          this.$router.replace("/404");
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
<style scoped lang="scss">
.grid {
  background: #f5f5f5;
  padding-bottom: 1px;

  .row {
    margin-bottom: 50px;
    background: #fff;
    padding: 16px 0px;
  }
}
</style>